export default __webpack_public_path__ + "static/media/v2_279.e0fd300f.png";